import RemitClaimCard from './RemitClaimCard';
export default RemitClaimCard;
